// Imports
import ___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___ from "../../node_modules/css-loader/dist/runtime/noSourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../node_modules/css-loader/dist/runtime/api.js";
import ___CSS_LOADER_GET_URL_IMPORT___ from "../../node_modules/css-loader/dist/runtime/getUrl.js";
var ___CSS_LOADER_URL_IMPORT_0___ = new URL("@/assets/pattern-background.svg", import.meta.url);
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___);
___CSS_LOADER_EXPORT___.push([module.id, "@import url(https://fonts.googleapis.com/css2?family=Jost:ital,wght@0,100;0,200;0,300;0,400;0,500;0,600;0,700;0,800;0,900;1,100;1,200;1,300;1,400;1,500;1,600;1,700;1,800;1,900&display=swap);"]);
var ___CSS_LOADER_URL_REPLACEMENT_0___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_0___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `/**
* @tokens Colors
* @presenter Color
*/
.brand-grey-400[data-v-68555a04] {
  color: #bdbdbd;
}
.brand-grey-500[data-v-68555a04] {
  color: #9e9e9e;
}
.brand-grey-600[data-v-68555a04] {
  color: #757575;
}
.brand-grey-700[data-v-68555a04] {
  color: #616161;
}
.status-error[data-v-68555a04] {
  color: #b00020;
}
.status-yellow[data-v-68555a04] {
  color: #aa8a22;
}
.status-success[data-v-68555a04] {
  color: #1eb980;
}
.status-success-grey-700[data-v-68555a04] {
  color: #616161;
}
.text-white[data-v-68555a04] {
  color: #fff;
}
.line[data-v-68555a04] {
  border: 1px solid #f4f2f7;
  margin-top: 2%;
  width: 100%;
  margin-bottom: 2%;
}
@media (max-width: 767px) {
.line[data-v-68555a04] {
    display: none;
}
}
@media (max-width: 767px) {
.mobile-line[data-v-68555a04] {
    border: 1px solid #f4f2f7;
    margin-right: 10%;
    width: 90%;
    margin-bottom: 2%;
}
}
.modal[data-v-68555a04] {
  left: 1%;
  position: relative;
  height: 100%;
  width: 98%;
  display: flex;
  flex-wrap: wrap;
  align-content: center;
  justify-content: center;
  align-items: center;
  flex-direction: row;
  padding-top: 30px;
}
@media (max-width: 767px) {
.modal[data-v-68555a04] {
    display: block;
    height: 95%;
}
}
.modal-container[data-v-68555a04] {
  height: 7%;
  width: 94%;
  margin: 3%;
}
@media (max-width: 767px) {
.modal-container[data-v-68555a04] {
    height: 12%;
}
}
.modal-header[data-v-68555a04] {
  height: 100%;
  width: 100%;
  display: flex;
  flex-direction: row;
  flex-wrap: wrap;
  align-content: center;
  justify-content: space-between;
}
@media (max-width: 767px) {
.modal-header[data-v-68555a04] {
    height: 85%;
}
}
.modal-header-container[data-v-68555a04] {
  position: relative;
  width: 100%;
  height: 100%;
  border-bottom: 1px solid #f4f2f7;
  margin: 0;
}
@media (max-width: 767px) {
.modal-header-container[data-v-68555a04] {
    display: flex;
    flex-direction: column;
    align-items: flex-start;
    justify-content: space-between;
    height: 100%;
}
}
.modal-header-container-subheading[data-v-68555a04] {
  display: none;
}
@media (max-width: 767px) {
.modal-header-container-subheading[data-v-68555a04] {
    display: inline-block;
    width: 100%;
    height: 25%;
    position: absolute;
    right: 0;
    display: flex;
    align-items: flex-end;
    justify-content: center;
    align-content: flex-end;
    flex-wrap: wrap;
    text-align: center;
    padding-top: 0;
    top: 80%;
    left: 0;
}
.modal-header-container-subheading > .modal-header-text[data-v-68555a04] {
    font-size: 13px;
    white-space: nowrap;
}
}
@media (max-width: 767px) {
.modal-header-container-text[data-v-68555a04] {
    width: 100%;
    height: 95%;
    position: absolute;
    right: 0;
    display: flex;
    align-items: flex-end;
    justify-content: center;
    align-content: flex-end;
    flex-wrap: wrap;
    text-align: center;
    padding-top: 0;
    top: 0;
    left: 0;
}
}
.modal-header-arrow[data-v-68555a04] {
  width: 10%;
  height: 100%;
  justify-content: center;
  cursor: pointer;
}
@media (max-width: 767px) {
.modal-header-arrow-image[data-v-68555a04] {
    width: 23px;
}
}
@media (max-width: 767px) {
.modal-header-arrow[data-v-68555a04] {
    z-index: 99999;
    padding-top: 0;
    width: 100%;
    height: 80%;
}
}
.modal-header-logo[data-v-68555a04] {
  display: none;
  width: 90%;
  height: 100%;
}
@media (max-width: 767px) {
.modal-header-logo[data-v-68555a04] {
    display: flex;
    width: 100%;
    height: 45%;
    position: absolute;
    left: 0;
    top: 0;
    z-index: 0;
    background-color: transparent;
    right: 0;
    justify-content: center;
    align-items: center;
}
}
@media (max-width: 767px) {
.modal-header-logo > img[data-v-68555a04] {
    width: 50%;
    height: 80%;
}
}
@media (max-width: 767px) {
.modal-header-progress[data-v-68555a04] {
    height: 95%;
    width: 100%;
    margin-top: 0;
    z-index: 0;
    position: absolute;
    background-color: transparent;
    display: flex;
    align-items: flex-end;
    justify-content: flex-start;
    align-content: flex-end;
    flex-wrap: wrap;
}
}
@media (max-width: 767px) and (max-width: 767px) {
.modal-header-progress > img[data-v-68555a04] {
    width: 15%;
    height: 20%;
}
}
.modal-header-text[data-v-68555a04] {
  width: 100%;
  height: 50%;
  color: #9e9e9e;
  margin-left: 2%;
  display: flex;
  align-items: flex-start;
  justify-content: space-around;
  font-family: Jost, sans-serif;
  font-size: 18px;
  font-weight: 500;
  line-height: 28px;
  letter-spacing: 0;
  text-align: center;
}
@media (max-width: 767px) {
.modal-header-text[data-v-68555a04] {
    margin-left: 0;
    display: contents;
    flex-direction: column;
    flex-wrap: nowrap;
    z-index: 0;
    background-color: transparent;
}
}
.modal-body[data-v-68555a04] {
  position: relative;
  height: 85%;
  width: 95%;
  text-align: center;
  font-family: Jost, sans-serif;
}
@media (max-width: 767px) {
.modal-body[data-v-68555a04] {
    width: 95%;
    overflow-y: scroll;
    overflow-x: hidden;
    margin-top: 29px;
    margin-left: 2.5%;
}
}
.modal_text-input-container[data-v-68555a04] {
  width: 100%;
  display: flex;
  flex-wrap: wrap;
  flex-direction: column;
  align-items: flex-start;
}
.modal_text-input-container_title[data-v-68555a04] {
  width: 448px;
  height: 20px;
  font-family: Jost, sans-serif;
  font-size: 14px;
  font-weight: 500;
  line-height: 20px;
  letter-spacing: 0;
  text-align: left;
  padding-bottom: 10px;
}
.modal_text-input-container_title > span[data-v-68555a04] {
  color: #757575;
  font-weight: 400;
}
.modal_text-input-container_single[data-v-68555a04] {
  width: 100%;
  margin-bottom: 15px;
}
@media (max-width: 767px) {
.modal_text-input-container_single[data-v-68555a04] {
    width: 95%;
}
}
.modal_text-input-container_double-column[data-v-68555a04] {
  display: flex;
  gap: 12px;
  flex-wrap: wrap;
  flex-direction: row;
  justify-content: flex-start;
  align-items: flex-end;
  width: 100%;
  margin-top: 0;
  padding-bottom: 15px;
}
@media (max-width: 767px) {
.modal_text-input-container_double-column[data-v-68555a04] {
    flex-direction: column;
    align-items: flex-start;
}
}
.modal_button-container[data-v-68555a04] {
  margin: 2% 0;
  height: 5%;
  display: flex;
  align-items: flex-end;
  width: 100%;
  position: absolute;
  bottom: 0;
  right: 0;
  left: 0;
}
@media (max-width: 767px) {
.modal_button-container[data-v-68555a04] {
    justify-content: center;
}
}
@media (max-width: 767px) {
.modal_button-container .yc--button[data-v-68555a04] {
    width: 100%;
}
}
@media (max-width: 767px) {
.logo[data-v-68555a04] {
    width: 100%;
    height: 100%;
}
}
body[data-v-68555a04] {
  margin: 0px;
  height: 100%;
}
html[data-v-68555a04] {
  padding: 0px;
  margin: 0px;
  font-family: "Jost", sans-serif;
  line-height: 1.5;
}
.view_component[data-v-68555a04] {
  margin: 0px;
  height: 100vh;
  box-sizing: border-box;
  display: flex;
  flex-direction: column;
  align-items: center;
  overflow: hidden;
  background-repeat: no-repeat;
  background-position: bottom;
  background-color: #2F1C50;
  padding-top: 72px;
  background-size: contain;
  background-image: url(${___CSS_LOADER_URL_REPLACEMENT_0___});
}
@media screen and (max-height: 800px) {
.view_component[data-v-68555a04] {
    padding-top: 15px;
}
}
.view_component-logo[data-v-68555a04] {
  padding-bottom: 50px;
}
@media screen and (max-height: 800px) {
.view_component-logo[data-v-68555a04] {
    padding-bottom: 5px;
}
}
@media (max-width: 768px) {
.view_component[data-v-68555a04] {
    background-color: #fff;
    background-image: none;
    padding-top: 0;
    min-height: 800px;
    overflow-y: scroll;
}
.view_component-logo[data-v-68555a04] {
    height: 30px;
    display: none;
}
}
.brand-grey-400[data-v-68555a04] {
  color: #bdbdbd;
}
.brand-grey-500[data-v-68555a04] {
  color: #9e9e9e;
}
.brand-grey-600[data-v-68555a04] {
  color: #757575;
}
.brand-grey-700[data-v-68555a04] {
  color: #616161;
}
.status-error[data-v-68555a04] {
  color: #b00020;
}
.status-yellow[data-v-68555a04] {
  color: #aa8a22;
}
.status-success[data-v-68555a04] {
  color: #1eb980;
}
.status-success-grey-700[data-v-68555a04] {
  color: #616161;
}
.text-white[data-v-68555a04] {
  color: #fff;
}
.line[data-v-68555a04] {
  border: 1px solid #f4f2f7;
  margin-top: 2%;
  width: 100%;
  margin-bottom: 2%;
}
@media (max-width: 767px) {
.line[data-v-68555a04] {
    display: none;
}
}
@media (max-width: 767px) {
.mobile-line[data-v-68555a04] {
    border: 1px solid #f4f2f7;
    margin-right: 10%;
    width: 90%;
    margin-bottom: 2%;
}
}
.modal[data-v-68555a04] {
  left: 1%;
  position: relative;
  height: 100%;
  width: 98%;
  display: flex;
  flex-wrap: wrap;
  align-content: center;
  justify-content: center;
  align-items: center;
  flex-direction: row;
  padding-top: 30px;
}
@media (max-width: 767px) {
.modal[data-v-68555a04] {
    display: block;
    height: 95%;
}
}
.modal-container[data-v-68555a04] {
  height: 7%;
  width: 94%;
  margin: 3%;
}
@media (max-width: 767px) {
.modal-container[data-v-68555a04] {
    height: 12%;
}
}
.modal-header[data-v-68555a04] {
  height: 100%;
  width: 100%;
  display: flex;
  flex-direction: row;
  flex-wrap: wrap;
  align-content: center;
  justify-content: space-between;
}
@media (max-width: 767px) {
.modal-header[data-v-68555a04] {
    height: 85%;
}
}
.modal-header-container[data-v-68555a04] {
  position: relative;
  width: 100%;
  height: 100%;
  border-bottom: 1px solid #f4f2f7;
  margin: 0;
}
@media (max-width: 767px) {
.modal-header-container[data-v-68555a04] {
    display: flex;
    flex-direction: column;
    align-items: flex-start;
    justify-content: space-between;
    height: 100%;
}
}
.modal-header-container-subheading[data-v-68555a04] {
  display: none;
}
@media (max-width: 767px) {
.modal-header-container-subheading[data-v-68555a04] {
    display: inline-block;
    width: 100%;
    height: 25%;
    position: absolute;
    right: 0;
    display: flex;
    align-items: flex-end;
    justify-content: center;
    align-content: flex-end;
    flex-wrap: wrap;
    text-align: center;
    padding-top: 0;
    top: 80%;
    left: 0;
}
.modal-header-container-subheading > .modal-header-text[data-v-68555a04] {
    font-size: 13px;
    white-space: nowrap;
}
}
@media (max-width: 767px) {
.modal-header-container-text[data-v-68555a04] {
    width: 100%;
    height: 95%;
    position: absolute;
    right: 0;
    display: flex;
    align-items: flex-end;
    justify-content: center;
    align-content: flex-end;
    flex-wrap: wrap;
    text-align: center;
    padding-top: 0;
    top: 0;
    left: 0;
}
}
.modal-header-arrow[data-v-68555a04] {
  width: 10%;
  height: 100%;
  justify-content: center;
  cursor: pointer;
}
@media (max-width: 767px) {
.modal-header-arrow-image[data-v-68555a04] {
    width: 23px;
}
}
@media (max-width: 767px) {
.modal-header-arrow[data-v-68555a04] {
    z-index: 99999;
    padding-top: 0;
    width: 100%;
    height: 80%;
}
}
.modal-header-logo[data-v-68555a04] {
  display: none;
  width: 90%;
  height: 100%;
}
@media (max-width: 767px) {
.modal-header-logo[data-v-68555a04] {
    display: flex;
    width: 100%;
    height: 45%;
    position: absolute;
    left: 0;
    top: 0;
    z-index: 0;
    background-color: transparent;
    right: 0;
    justify-content: center;
    align-items: center;
}
}
@media (max-width: 767px) {
.modal-header-logo > img[data-v-68555a04] {
    width: 50%;
    height: 80%;
}
}
@media (max-width: 767px) {
.modal-header-progress[data-v-68555a04] {
    height: 95%;
    width: 100%;
    margin-top: 0;
    z-index: 0;
    position: absolute;
    background-color: transparent;
    display: flex;
    align-items: flex-end;
    justify-content: flex-start;
    align-content: flex-end;
    flex-wrap: wrap;
}
}
@media (max-width: 767px) and (max-width: 767px) {
.modal-header-progress > img[data-v-68555a04] {
    width: 15%;
    height: 20%;
}
}
.modal-header-text[data-v-68555a04] {
  width: 100%;
  height: 50%;
  color: #9e9e9e;
  margin-left: 2%;
  display: flex;
  align-items: flex-start;
  justify-content: space-around;
  font-family: Jost, sans-serif;
  font-size: 18px;
  font-weight: 500;
  line-height: 28px;
  letter-spacing: 0;
  text-align: center;
}
@media (max-width: 767px) {
.modal-header-text[data-v-68555a04] {
    margin-left: 0;
    display: contents;
    flex-direction: column;
    flex-wrap: nowrap;
    z-index: 0;
    background-color: transparent;
}
}
.modal-body[data-v-68555a04] {
  position: relative;
  height: 85%;
  width: 95%;
  text-align: center;
  font-family: Jost, sans-serif;
}
@media (max-width: 767px) {
.modal-body[data-v-68555a04] {
    width: 95%;
    overflow-y: scroll;
    overflow-x: hidden;
    margin-top: 29px;
    margin-left: 2.5%;
}
}
.modal_text-input-container[data-v-68555a04] {
  width: 100%;
  display: flex;
  flex-wrap: wrap;
  flex-direction: column;
  align-items: flex-start;
}
.modal_text-input-container_title[data-v-68555a04] {
  width: 448px;
  height: 20px;
  font-family: Jost, sans-serif;
  font-size: 14px;
  font-weight: 500;
  line-height: 20px;
  letter-spacing: 0;
  text-align: left;
  padding-bottom: 10px;
}
.modal_text-input-container_title > span[data-v-68555a04] {
  color: #757575;
  font-weight: 400;
}
.modal_text-input-container_single[data-v-68555a04] {
  width: 100%;
  margin-bottom: 15px;
}
@media (max-width: 767px) {
.modal_text-input-container_single[data-v-68555a04] {
    width: 95%;
}
}
.modal_text-input-container_double-column[data-v-68555a04] {
  display: flex;
  gap: 12px;
  flex-wrap: wrap;
  flex-direction: row;
  justify-content: flex-start;
  align-items: flex-end;
  width: 100%;
  margin-top: 0;
  padding-bottom: 15px;
}
@media (max-width: 767px) {
.modal_text-input-container_double-column[data-v-68555a04] {
    flex-direction: column;
    align-items: flex-start;
}
}
.modal_button-container[data-v-68555a04] {
  margin: 2% 0;
  height: 5%;
  display: flex;
  align-items: flex-end;
  width: 100%;
  position: absolute;
  bottom: 0;
  right: 0;
  left: 0;
}
@media (max-width: 767px) {
.modal_button-container[data-v-68555a04] {
    justify-content: center;
}
}
@media (max-width: 767px) {
.modal_button-container .yc--button[data-v-68555a04] {
    width: 100%;
}
}
@media (max-width: 767px) {
.logo[data-v-68555a04] {
    width: 100%;
    height: 100%;
}
}
.authorize-container[data-v-68555a04] {
  display: flex;
  flex-direction: column;
  box-sizing: border-box;
  width: 100%;
  height: 100%;
  padding: 20px 20px 0 20px;
  font-family: Jost, sans-serif;
  overflow-x: hidden;
}
@media (max-width: 767px) {
.authorize-container[data-v-68555a04] {
    height: auto;
    padding: 15px 20px 0 20px;
}
}
.authorize-header[data-v-68555a04] {
  display: flex;
  justify-content: center;
  border-bottom: 2px solid #f4f2f7;
  padding: 5px 0 15px 0;
  margin: 0 0 20px 0;
  color: #9e9e9e;
  font-size: 18px;
  font-weight: 500;
}
@media (max-width: 767px) {
.authorize-header[data-v-68555a04] {
    display: none;
}
}
.authorize-header-logo > img[data-v-68555a04] {
  width: 180px;
  height: 35px;
}
.authorize-header-text[data-v-68555a04] {
  display: flex;
  justify-content: center;
  color: #9e9e9e;
  font-size: 18px;
  font-weight: 500;
  flex-grow: 1;
}
.authorize-header-mobile[data-v-68555a04] {
  display: none;
}
@media (max-width: 767px) {
.authorize-header-mobile[data-v-68555a04] {
    display: flex;
    flex-direction: column;
    align-items: center;
    border-bottom: 2px solid #f4f2f7;
    padding-bottom: 3px;
    margin: 0 0 20px 0;
}
}
.authorize-body[data-v-68555a04] {
  display: flex;
  flex-direction: column;
  flex-grow: 1;
  min-height: 0;
  overflow-y: auto;
}
@media (max-width: 767px) {
.authorize-body[data-v-68555a04] {
    overflow-y: visible;
}
}
.authorize-body-centered[data-v-68555a04] {
  align-items: center;
  text-align: center;
}
.authorize-body-heading[data-v-68555a04] {
  font-size: 20px;
  font-weight: 500;
  line-height: 28px;
  color: #000000;
  padding-bottom: 6px;
}
.authorize-body-description[data-v-68555a04] {
  font-size: 14px;
  font-weight: 400;
  line-height: 20px;
  color: #616161;
  padding-bottom: 14px;
}
.authorize-amounts[data-v-68555a04] {
  background-color: #fafafa;
  border-radius: 8px;
  padding: 2px 16px;
  margin-bottom: 2px;
}
.authorize-amounts-leg[data-v-68555a04] {
  display: flex;
  align-items: center;
  justify-content: space-between;
  gap: 12px;
  padding: 11px 0;
}
.authorize-amounts-leg-label[data-v-68555a04] {
  display: flex;
  align-items: center;
  gap: 8px;
  font-size: 14px;
  color: #616161;
  white-space: nowrap;
}
.authorize-amounts-leg-label-icon[data-v-68555a04] {
  width: 20px;
  height: 20px;
}
.authorize-amounts-leg-value[data-v-68555a04] {
  font-size: 18px;
  font-weight: 500;
  line-height: 24px;
  color: #000000;
  text-align: right;
  word-break: break-word;
}
.authorize-amounts-leg-value-currency[data-v-68555a04] {
  font-size: 14px;
  color: #616161;
}
.authorize-amounts-divider[data-v-68555a04] {
  display: flex;
  align-items: center;
  gap: 10px;
}
.authorize-amounts-divider-line[data-v-68555a04] {
  flex: 1;
  height: 1px;
  background-color: #e0e0e0;
}
.authorize-amounts-divider-icon[data-v-68555a04] {
  display: flex;
  align-items: center;
  justify-content: center;
  width: 24px;
  height: 24px;
  border-radius: 50%;
  background-color: #ffffff;
  border: 1px solid #e0e0e0;
}
.authorize-amounts-divider-icon > img[data-v-68555a04] {
  width: 10px;
  opacity: 0.45;
}
.authorize-details[data-v-68555a04] {
  display: flex;
  flex-direction: column;
  width: 100%;
}
.authorize-details-row[data-v-68555a04] {
  display: flex;
  justify-content: space-between;
  align-items: center;
  gap: 12px;
  padding: 9px 0;
  border-bottom: 1px solid #f4f2f7;
  font-size: 14px;
  line-height: 20px;
  text-align: left;
}
.authorize-details-row[data-v-68555a04]:last-child {
  border-bottom: none;
}
.authorize-details-label[data-v-68555a04] {
  color: #616161;
  white-space: nowrap;
}
.authorize-details-value[data-v-68555a04] {
  display: flex;
  flex-direction: column;
  align-items: flex-end;
  font-weight: 500;
  color: #000000;
  word-break: break-word;
  text-align: right;
}
.authorize-details-value-sub[data-v-68555a04] {
  font-size: 12px;
  font-weight: 400;
  line-height: 16px;
  color: #757575;
}
.authorize-outcome-badge[data-v-68555a04] {
  display: flex;
  align-items: center;
  justify-content: center;
  width: 64px;
  height: 64px;
  border-radius: 50%;
  background-color: #dcede8;
  margin: 16px 0 20px 0;
}
.authorize-outcome-badge > img[data-v-68555a04] {
  width: 36px;
  height: 36px;
}
.authorize-outcome-image[data-v-68555a04] {
  display: flex;
  align-items: center;
  justify-content: center;
  margin-bottom: 12px;
}
.authorize-outcome-image > img[data-v-68555a04] {
  width: 100%;
  max-width: 120px;
}
.authorize-footer[data-v-68555a04] {
  display: flex;
  flex-direction: column;
  align-items: center;
  width: 100%;
  padding: 10px 0 12px 0;
}
@media (max-width: 767px) {
.authorize-footer[data-v-68555a04] {
    padding-bottom: 40px;
}
}
.authorize-footer-expiry[data-v-68555a04] {
  font-size: 12px;
  color: #757575;
  padding-bottom: 10px;
}
.authorize-footer-expiry-urgent[data-v-68555a04] {
  color: #b00020;
  font-weight: 500;
}
.authorize-footer-error[data-v-68555a04] {
  font-size: 12px;
  color: #b00020;
  text-align: center;
  padding-bottom: 10px;
}
.authorize-footer .yc--button[data-v-68555a04] {
  border-radius: 72px;
  font-family: Jost, "sans-serif";
  font-size: 16px;
  border: none !important;
}
.authorize-footer .yc--button.loading[data-v-68555a04] {
  cursor: default;
  pointer-events: none;
}`, ""]);
// Exports
export default ___CSS_LOADER_EXPORT___;
